module.exports = __webpack_public_path__ + "img/knuvu-screen-2.f7303922.png";